// extracted by mini-css-extract-plugin
export default {"header":"header_header__eIz+e","innerContainer":"header_innerContainer__xhsr5 layout_container__hEZs0","text":"header_text__zDxZT","logo":"header_logo__9uDRF"};